jQuery(document).ready(function () {


  if (jQuery(window).width() < 768) {
    $(".product-shop-more-sec .shop-more-wrap").slick({
      infinite: !1,
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: !1,
      responsive: [
        { breakpoint: 577, settings: { slidesToShow: 1, slidesToScroll: 1 } },
      ],
    });
    $(".product-shop-more-sec .shop-product-wrap .product-row").slick({
      infinite: !1,
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: !1,
      responsive: [
        { breakpoint: 577, settings: { slidesToShow: 1, slidesToScroll: 1 } },
      ],
    });
  }
  if (jQuery(window).width() > 767) {
    jQuery(".masonry-gallery-box .item-box-wrap:nth-child(odd)").addClass(
      "left"
    );
    jQuery(
      ".masonry-gallery-box:not(.collection) .item-box-wrap:nth-child(even)"
    ).addClass("right");
    jQuery(
      ".masonry-gallery-box.collection .item-box-wrap:nth-child(even):not(:last-of-type)"
    ).addClass("right");
    jQuery(
      ".masonry-gallery-box.collection .item-box-wrap:last-of-type"
    ).addClass("left");
    jQuery(".masonry-gallery-box .left").wrapAll(
      '<div class="wrap-left"></div>'
    );
    jQuery(".masonry-gallery-box .right").wrapAll(
      '<div class="wrap-right"></div>'
    );
  }
    
  


  jQuery(".site-header__search-toggle").click(function () {
    jQuery("header.site-header").toggleClass("search-active");
  });
  jQuery("#SearchDrawer .search-bar__input").focus(function () {
    jQuery(this).parents(".search-form__input-wrapper").addClass("focused");
  });
  jQuery("#SearchDrawer .search-bar__input").blur(function () {
    jQuery(this).parents(".search-form__input-wrapper").removeClass("focused");
  });
  jQuery("header.site-header .site-nav li:not(.no_megamenu) a").on(
    "click mouseenter",
    function (e) {
      e.preventDefault();
      var seleted = $(this).parent().attr("data-ref-nav");
      jQuery(".site-header").addClass("header-light-inner");
      jQuery("header.site-header .mega-menu-box").removeClass(
        "mega-menu-active"
      );
      jQuery("header.site-header .mega-menu-box." + seleted).addClass(
        "mega-menu-active"
      );
    }
  );
  jQuery("header.site-header .site-nav li.no_megamenu a").on(
    "click mouseenter",
    function (e) {
      jQuery(".site-header").removeClass("header-light-inner");
      jQuery("header.site-header .mega-menu-box").removeClass(
        "mega-menu-active"
      );
    }
  );
  jQuery(
    "header.site-header .mega-menu-box .left-content-box, header.site-header"
  ).mouseleave(function () {
    jQuery(".site-header").removeClass("header-light-inner");
    jQuery("header.site-header .mega-menu-box").removeClass("mega-menu-active");
  });
  jQuery(".mega-menu-box .mega-menu-items ul li a").mouseenter(function () {
    jQuery(".mega-menu-box .mega-menu-items ul li a").removeClass(
      "activated_nav"
    );
    $(this).addClass("activated_nav");
    var getActiveItem = jQuery(this).attr("data-attr");
    jQuery(this)
      .closest(".mega-menu-box")
      .find(".image-change-box .img-box")
      .removeClass("active");
    jQuery(this)
      .closest(".mega-menu-box")
      .find(".image-change-box .img-box")
      .addClass("hide");
    jQuery(
      ".mega-menu-box .image-change-box .img-box." + getActiveItem
    ).addClass("active");
    jQuery(
      ".mega-menu-box .image-change-box .img-box." + getActiveItem
    ).removeClass("hide");
  });
  jQuery("#SiteNav li[data-ref-nav=studio] a").mouseenter(function () {
    var getActiveItem = jQuery(this).parent().attr("data-ref-nav");
  });
  jQuery(".site-header__icons .site-nav-toggle-btn .icon-hamburger").click(
    function () {
      jQuery("header.site-header .site-nav-wrap").addClass("menu-active");
      jQuery(".site-header__icons .site-nav-toggle-btn").addClass("menu-close");
      jQuery(".site-header").addClass("header-light-inner");
    }
  );
  jQuery(".site-header__icons .site-nav-toggle-btn .icon-close").click(
    function () {
      jQuery("header.site-header .site-nav-wrap").removeClass("menu-active");
      jQuery(".site-header__icons .site-nav-toggle-btn").removeClass(
        "menu-close"
      );
      jQuery("header.site-header .mega-menu-box").removeClass(
        "mega-menu-active"
      );
      jQuery(".site-header").removeClass("header-light-inner");
    }
  );
  jQuery(".mega-menu-box .mega-menu-close-btn").click(function () {
    jQuery("header.site-header .mega-menu-box").removeClass("mega-menu-active");
  });
  jQuery(".scroll-to-id").click(function (e) {
    e.preventDefault();
    var sectionID = jQuery(this).attr("href");
    jQuery("html, body").animate(
      { scrollTop: jQuery(sectionID).offset().top - 100 },
      500
    );
  });
  $(".collection-page-filter .heading-with-btn .btn-box .btn").click(function (
    e
  ) {
    e.preventDefault();
    $(".collection-page-filter").toggleClass("filter-active");
  });
  $(".product-filter .filter-tabs h2").click(function () {
    var selectedTab = $(this).attr("data-attr");
    $(".product-filter .filter-tabs h2").removeClass("active");
    $(this).addClass("active");
    $(".product-filter .filter-box").removeClass("active");
    $(".product-filter .filter-box#" + selectedTab).addClass("active");
  });
  $(".product-filter .filter-box ul li .select").click(function () {
    $(this).parents("li").addClass("selected");
  });
  $(".product-filter .filter-box ul li .deselect").click(function () {
    $(this).parents("li").removeClass("selected");
  });
  $(".product-filter .filter-box .filter-toggle-text").click(function () {
    $(".product-filter .filter-box .filter-toggle-text").removeClass("active");
    $(this).addClass("active");
    $(".product-filter .filter-box .filter-toggle-text")
      .not(this)
      .siblings(".filter-row")
      .slideUp();
    $(this).siblings(".filter-row").slideDown();
    $(".collection-page-filter .product-filter .filter-box").removeClass(
      "active"
    );
    $(this).parents(".filter-box").addClass("active");
    var selectedTabMob = $(this).attr("data-attr");
    $(".product-filter .filter-tabs h2").removeClass("active");
    $(
      '.product-filter .filter-tabs h2[data-attr="' + selectedTabMob + '"]'
    ).addClass("active");
  });
  // $(".collection-card-wrap.slider").slick({
  //   infinite: !1,
  //   slidesToShow: 2,
  //   slidesToScroll: 2,
  //   arrows: !0,
  //   responsive: [
  //     { breakpoint: 992, settings: { slidesToShow: 1, slidesToScroll: 1 } },
  //   ],
  // });
  $(".collection-card-wrap:not(.product-card-wrap).slider").each(function () {
    const $this = $(this)
    const slideCount = $this.data('slide-count-setting') || 2
  
    $this.slick({
      infinite: false,
      slidesToShow: slideCount,
      slidesToScroll: slideCount,
      arrows: !0,
      responsive: [
        { breakpoint: 992, settings: { slidesToShow: 1, slidesToScroll: 1 } },
      ],
    })
  })
  // $(".collection-card-wrap.product-card-wrap.slider").each(function () {
  //   const $this = $(this)
  //   const slideCount = $this.data('slide-count-setting') || 2
  
  //   $this.slick({
  //     infinite: false,
  //     slidesToShow: slideCount,
  //     slidesToScroll: 1,
  //     arrows: !0,
  //     responsive: [
  //       { breakpoint: 992, settings: { slidesToShow: 1, slidesToScroll: 1 } },
  //     ],
  //   })
  // })
  $(".product-customization-sec .content-row").slick({
    infinite: !1,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: !1,
    responsive: [
      { breakpoint: 768, settings: { slidesToShow: 1, slidesToScroll: 1 } },
    ],
  });
  $(".product-details-sec .img-slide-box").slick({
    infinite: !1,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: !0,
    arrows: !1,
    asNavFor: ".product-details-sec .img-slide-box-text",
  });
  $(".product-details-sec .img-slide-box-text").slick({
    infinite: !1,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: !1,
    fade: !0,
    arrows: !1,
    asNavFor: ".product-details-sec .img-slide-box",
  });
  $(".glass-table-data table > tbody > tr").on("mouseenter", function () {
    var index = parseInt($(this).data("index")) - 1;
    console.log(index);
    setTimeout(function () {
      $(".product-details-sec .img-slide-box").slick("slickGoTo", index);
    }, 200);
  });
  $(".more-content-sec .content-slider").slick({
    infinite: !1,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: !0,
    arrows: !1,
    responsive: [
      { breakpoint: 992, settings: { slidesToShow: 2 } },
      { breakpoint: 577, settings: { slidesToShow: 1 } },
    ],
  });
  jQuery(".customize-popup-open-btn").click(function (e) {
    e.preventDefault();
    jQuery(".custom-order-popup").fadeIn();
  });
  jQuery(".custom-order-popup .popup-close-icon").click(function () {
    jQuery(".custom-order-popup").fadeOut();
  });
  jQuery(
    ".product-details-sec .additional-info-box .customize-popup-open-btn"
  ).click(function (e) {
    e.preventDefault();
    jQuery("html, body").animate(
      { scrollTop: $(".collection-single-sec").offset().top - 150 },
      500
    );
  });
  jQuery(".accordion-panel.active .body-content").slideDown();

  // Pre-fix
//   jQuery(".accordion-panel .title").click(function () {
//     jQuery(".accordion-panel .title")
//       .not(this)
//       .parents(".accordion-panel")
//       .removeClass("active");
//     jQuery(this).parents(".accordion-panel").toggleClass("active");
//     jQuery(".accordion-panel .title")
//       .not(this)
//       .siblings(".body-content")
//       .slideUp();
//     setTimeout(function () {
//       var kp = jQuery(".accordion-panel.active").offset();
//       jQuery("html:not(:animated), body:not(:animated)").animate(
//         { scrollTop: kp.top - 72 },
//         500
//       );
//       AOS.init();
//     }, 500);
//     jQuery(".accordion-panel.active .body-content").slideToggle("fast");
//   });
  
  jQuery(".accordion-panel .title").click(function () {
    AOS.refresh();
    var $thisPanel = jQuery(this).closest(".accordion-panel");
    var $otherPanels = jQuery(".accordion-panel").not($thisPanel);

    // Remove active class and slide up content for other panels
    $otherPanels.removeClass("active");
    $otherPanels.find(".body-content").slideUp();

    // Toggle active class for the clicked panel and slide toggle content
    $thisPanel.toggleClass("active");
    $thisPanel.find(".body-content").slideToggle("fast");

    // Scroll to the active panel after animations are complete
    setTimeout(function () {
      if ($thisPanel.hasClass("active")) {
        var kp = $thisPanel.offset();
        jQuery("html, body").animate(
          { scrollTop: kp.top - 72 },
          500
        );
        AOS.init();
        setTimeout(function () {
          AOS.refresh();
        }, 500)
      }
      AOS.refresh();
    }, 400); // Adjust timeout to match animation duration
    
  });
  
  jQuery(".faq-accordion-panel.active .faq-content").slideDown();
  jQuery(".faq-accordion-panel .title-box").click(function () {
    jQuery(".faq-accordion-panel .title-box")
      .not(this)
      .parents(".faq-accordion-panel")
      .removeClass("active");
    jQuery(this).parents(".faq-accordion-panel").toggleClass("active");
    jQuery(".faq-accordion-panel .title-box")
      .not(this)
      .siblings(".faq-content")
      .slideUp();
    jQuery(this).siblings(".faq-content").slideToggle();
  });
  jQuery(".accordion.product-nav-content .title-box").click(function () {
    jQuery(this).toggleClass("active");
    jQuery(this).siblings(".accordion-content").slideToggle();
    $(".other-variants-slider").slick("refresh");
    $(".product-customization-sec .content-row").slick("refresh");
  });
  jQuery(".other-variants-slider").slick({
    infinite: !0,
    dots: !1,
    autoplay: !0,
    arrows: !1,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 992, settings: { slidesToShow: 2 } },
      { breakpoint: 577, settings: { slidesToShow: 1 } },
    ],
  });
  
  var slider = jQuery(".masonry-gallery-box .img-box.has-slider");
  slider.each(function (index) {
    jQuery(this).slick({
      infinite: !0,
      dots: !0,
      autoplay: !1,
      arrows: !1,
      speed: 1200,
      slidesToShow: 1,
      slidesToScroll: 1,
    });
  });
  jQuery().fancybox({
    selector:
      ".custom-large-gallery .masonry-gallery-box .img-box a",
    caption: function (instance, item) {
      return jQuery(this).find(".caption").html();
    },
  });
  jQuery().fancybox({
    selector:
      ".custom-small-gallery .masonry__item a",
    caption: function (instance, item) {
      return jQuery(this).find(".caption").html();
    },
  });
  jQuery().fancybox({
    selector: ".product-gallery-wrap .item-box:not(.slick-cloned)",
    caption: function (instance, item) {
      return jQuery(this).find(".caption").html();
    },
  });
  jQuery("body").on("click", ".fb-caption-toggle-btn", function (event) {
    event.preventDefault();
    jQuery(".fancybox-caption__body").toggleClass("inactive");
  });
  jQuery(".product-image-gallery .product-gallery-wrap").slick({
    infinite: !0,
    dots: !0,
    autoplay: !1,
    arrows: !0,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 992, settings: { slidesToShow: 2 } },
      { breakpoint: 578, settings: { slidesToShow: 1 } },
    ],
  });
  var masonryOptions = { itemSelector: ".item-box", gutter: 150 };
  jQuery(".product-image-gallery .view-type .grid-gallery-view").click(
    function () {
      jQuery(".product-image-gallery .view-type button").removeClass("active");
      jQuery(this).addClass("active");
      jQuery(".product-image-gallery .product-gallery-wrap").slick("unslick");
      jQuery(".product-image-gallery .product-gallery-wrap").removeClass(
        "slider"
      );
      jQuery(".product-image-gallery .product-gallery-wrap").addClass(
        "grid-gallery"
      );
      $(".product-gallery-wrap").masonry(masonryOptions);
    }
  );
  jQuery(".product-image-gallery .view-type .slide-gallery-view").click(
    function () {
      jQuery(".product-image-gallery .view-type button").removeClass("active");
      jQuery(this).addClass("active");
      jQuery(".product-image-gallery .product-gallery-wrap").addClass("slider");
      jQuery(".product-image-gallery .product-gallery-wrap").removeClass(
        "grid-gallery"
      );
      $(".product-gallery-wrap").masonry("destroy");
      setTimeout(function () {
        jQuery(".product-image-gallery .product-gallery-wrap").slick({
          infinite: !0,
          dots: !0,
          autoplay: !1,
          arrows: !0,
          speed: 300,
          slidesToShow: 3,
          slidesToScroll: 1,
          responsive: [
            { breakpoint: 992, settings: { slidesToShow: 2 } },
            { breakpoint: 578, settings: { slidesToShow: 1 } },
          ],
        });
      }, 500);
    }
  );
  jQuery(".custom-grid-list-sec .heading-with-btn .view-type-grid").click(
    function () {
      jQuery(".custom-grid-list-sec .heading-with-btn button").removeClass(
        "active"
      );
      jQuery(this).addClass("active");
      jQuery(".custom-grid-list-sec").removeClass("list-active");
      jQuery(".custom-projects-grid").show();
      jQuery(".custom-projects-list").hide();
      setTimeout(function () {
        AOS.init();
      }, 500);
    }
  );
  jQuery(".custom-grid-list-sec .heading-with-btn .view-type-list").click(
    function () {
      jQuery(".custom-grid-list-sec .heading-with-btn button").removeClass(
        "active"
      );
      jQuery(this).addClass("active");
      jQuery(".custom-grid-list-sec").addClass("list-active");
      jQuery(".custom-projects-grid").hide();
      jQuery(".custom-projects-list").show();
      setTimeout(function () {
        AOS.init();
      }, 500);
    }
  );
  jQuery(
    ".gallery-filter-box .gallery-view-dropdown .filter-by-dropdown"
  ).click(function () {
    jQuery(".gallery-page-header").toggleClass("dropdown-active");
    jQuery(
      ".gallery-filter-box .gallery-view-dropdown .filter-list-dropdown"
    ).fadeToggle();
  });
  jQuery(document).on("click", function (event) {
    if (
      !jQuery(event.target).closest(
        ".gallery-filter-box .gallery-view-dropdown .filter-by-dropdown"
      ).length
    ) {
      jQuery(".gallery-page-header").removeClass("dropdown-active");
      jQuery(
        ".gallery-filter-box .gallery-view-dropdown .filter-list-dropdown"
      ).fadeOut();
    }
  });
  $(document).on("keydown", function (event) {
    if (event.key == "Escape") {
      jQuery(".gallery-page-header").removeClass("dropdown-active");
      jQuery(
        ".gallery-filter-box .gallery-view-dropdown .filter-list-dropdown"
      ).fadeOut();
    }
  });
  jQuery(
    ".gallery-filter-box .gallery-view-dropdown .filter-list-dropdown ul li"
  ).click(function () {
    event.preventDefault();
    var selectedText = jQuery(this).text();
    var selectedAttr = jQuery(this).data("attr");

    jQuery(".gallery-page-header").removeClass("dropdown-active");
    jQuery(".gallery-filter-box .gallery-view-dropdown .filter-list-dropdown").fadeOut();
    
    filterGallery(selectedText, selectedAttr);
  });



  $(window).on("popstate", function (e) {
    $(".custom-large-gallery").load(" .custom-large-gallery .container");
    $(".custom-small-gallery").load(" .custom-small-gallery .container");
  });


  jQuery(".gallery-filter-box .view-type .small-gallery-view").click(
    function () {
      jQuery(".custom-small-gallery .container").css("visibility", "hidden");  
      jQuery(".gallery-filter-box .view-type button").removeClass("active");
      jQuery(this).addClass("active");
      jQuery(".custom-small-gallery").removeClass("hide_with_existance");
      jQuery(".custom-large-gallery").hide();
      jQuery(".custom-small-gallery").show();
      jQuery(".filter-list-dropdown li a").each(function () {
        var urldata = jQuery(this).attr("href");
        if (urldata.includes("constraint")) {
          urldata = jQuery(this).attr("href").split("&")[0];
        }
        jQuery(this).attr("href", urldata + "&constraint=small");
      });
      setTimeout(function () {
          imagesLoaded(".js-images-loaded", () => {
            new Masonry(document.querySelector(".js-masonry"), {
              itemSelector: ".js-masonry-item",
              columnWidth: ".grid-sizer",
              horizontalOrder: !0,
              gutter: ".gutter-sizer",
            });
          });
          jQuery(".custom-small-gallery .container").css("visibility", "visible");
        }, 500);
    }
  );
  jQuery(".gallery-filter-box .view-type .large-gallery-view").click(
    function () {
      jQuery(".custom-large-gallery .container").css("visibility", "hidden");  
      jQuery(".gallery-filter-box .view-type button").removeClass("active");
      jQuery(this).addClass("active");
      jQuery(".custom-large-gallery").removeClass("hide_with_existance");
      jQuery(".custom-large-gallery").show();
      jQuery(".custom-small-gallery").hide();
      jQuery(".filter-list-dropdown li a").each(function () {
        var urldata = jQuery(this).attr("href");
        if (urldata.includes("constraint")) {
          urldata = jQuery(this).attr("href").split("&")[0];
        }
        jQuery(this).attr("href", urldata + "&constraint=large");
      });

      setTimeout(function () {
          rebuildLargeGallery();
          jQuery(".custom-large-gallery .container").css("visibility", "visible");
      }, 500);
      
    }
  );
  if ($(".single-product-nav").length > 0) {
    $("html,.page-container").css("overflow", "visible");
  }
  var contentSection = $(".single-product-details .product-nav-content");
  var navigation = $(".single-product-nav");
  navigation.on("click", "a", function (event) {
    event.preventDefault();
    smoothScroll($(this.hash));
  });
  $(window).on("scroll", function () {
    updateNavigation();
    var activeNav = $(".single-product-nav ul li.active").last("a").text();
    console.log(activeNav);
    $(".single-product-nav .mobile-nav-text .text").text(activeNav);
  });
  updateNavigation();
  function updateNavigation() {
    contentSection.each(function () {
      var sectionName = $(this).attr("id");
      var navigationMatch = $(
        '.single-product-nav a[href="#' + sectionName + '"]'
      );
      $(".single-product-nav ul li:first-child").addClass("active");
      if (
        $(this).offset().top - $(window).height() / 2 < $(window).scrollTop() &&
        $(this).offset().top + $(this).height() - $(window).height() / 4 >
          $(window).scrollTop()
      ) {
        navigationMatch.parents("li").addClass("active");
      } else {
        navigationMatch.parents("li").removeClass("active");
      }
    });
  }
  function smoothScroll(target) {
    $("body,html").animate({ scrollTop: target.offset().top - 70 }, 800);
  }
  if ($(window).width() < 768) {
    $(".single-product-nav .mobile-nav-text").click(function () {
      $(this).siblings("ul").slideToggle();
    });
    $(".single-product-nav ul li a").click(function () {
      $(this).parents("ul").slideUp();
    });
  }
  $(".product-meta-box .see-more .btn--1").click(function () {
    //$(".product-details-sec .product-meta-box .material-table:not(.glass-table-data) .table_wrap").toggleClass("expanded");
    $(".product-details-sec .product-meta-box .material-table .table_wrap--1").toggleClass("expanded");
    $(this).toggleClass("active");
  });
  $(".product-meta-box .see-more .btn--2").click(function () {
    //$(".product-details-sec .product-meta-box .material-table:not(.glass-table-data) .table_wrap").toggleClass("expanded");
    $(".product-details-sec .product-meta-box .material-table .table_wrap--2").toggleClass("expanded");
    $(this).toggleClass("active");
  });
  $(".reset_all").click(function (e) {
    e.preventDefault();
    if (window.location.href.includes("?q=")) {
      var url = window.location.href.split("?q=")[0];
      window.location.href = url;
    } else {
      $(".product-filter").find("li.selected").removeClass("selected");
    }
  });
  $(".apply_filter").click(function () {
    var filter = "";
    $(".product-filter li.selected").each(function () {
      if (filter != "") {
        filter = filter + "+" + $(this).attr("data-check");
      } else {
        filter = filter + $(this).attr("data-check");
      }
      if (window.location.href.includes("?q=")) {
        var url = window.location.href.split("?q=")[0];
        window.location.href = url + "?q=" + filter;
      } else {
        window.location.href = window.location.href + "?q=" + filter;
      }
    });
  });
  $(".add").click(function () {
    $(this)
      .prev()
      .val(+$(this).prev().val() + 1);
  });
  $(".sub").click(function () {
    if ($(this).next().val() > 1) {
      if ($(this).next().val() > 1)
        $(this)
          .next()
          .val(+$(this).next().val() - 1);
    }
  });
  if ($(".cart__qty select").length) {
    $(".cart__qty select").selectric({
      arrowButtonMarkup: '<b class="button"></b>',
    });
  }
  if ($(".collection-carousel").length) {
    $(".collection-carousel").slick({
      autoplaySpeed: 300,
      speed: 1600,
      fade: !0,
      infinite: !0,
      cssEase: "ease-in-out",
      lazyLoad: "ondemand",
      slidesToShow: 1,
      slidesToScroll: 1,
    });
    $(".collection-carousel .slick-list").mouseover(function () {
      $(this).parent().slick("slickPlay");
    });
    $(".collection-carousel .slick-list").mouseout(function () {
      $(this).parent().slick("slickPause");
    });
  }

  setTimeout(function () {
      imagesLoaded(".js-images-loaded", () => {
        new Masonry(document.querySelector(".js-masonry"), {
          itemSelector: ".js-masonry-item",
          columnWidth: ".grid-sizer",
          horizontalOrder: !0,
          gutter: ".gutter-sizer",
        });
      });
    }, 500);

  function rebuildMasonry(){
      console.log("rebuild");
      // destroy masonry
      jQuery('.js-masonry').masonry('destroy');
      jQuery('.js-masonry').removeData('masonry'); // This line to remove masonry's data

      // re-init masonry again.
      jQuery('.js-masonry').masonry({
        itemSelector: ".js-masonry-item",
        columnWidth: ".grid-sizer",
        horizontalOrder: true,
        gutter: ".gutter-sizer",
      });
  }

  function rebuildLargeGallery(){
    jQuery(".masonry-gallery-box .left").unwrap(); 
    jQuery(".masonry-gallery-box .right").unwrap();
    

    if (jQuery(window).width() > 767) {
      
      // remove left & right classes
      jQuery(".masonry-gallery-box .item-box-wrap").removeClass("left right");

      // add left & right classes
      jQuery(".masonry-gallery-box .item-box-wrap:visible:nth-child(odd)").addClass("left");
      jQuery(
        ".masonry-gallery-box:not(.collection) .item-box-wrap:visible:nth-child(even)"
      ).addClass("right");

      // wrap left & right
      jQuery(
        ".masonry-gallery-box.collection .item-box-wrap:visible:nth-child(even):not(:last-of-type)"
      ).addClass("right");
      jQuery(
        ".masonry-gallery-box.collection .item-box-wrap:visible:last-of-type"
      ).addClass("left");

      jQuery(".masonry-gallery-box .right").wrapAll(
        '<div class="wrap-right"></div>'
      );
      jQuery(".masonry-gallery-box .left").wrapAll(
          '<div class="wrap-left"></div>'
        );
    }

    jQuery(".custom-large-gallery .container").css("visibility", "visible");
  }

  function filterGallery(collectionName, collection){

    jQuery(".custom-large-gallery .container").css("visibility", "hidden");

    jQuery(".gallery-filter-box .gallery-view-dropdown .filtered-cat").text(
      collectionName
    );

    jQuery("[data-category]").hide();
    jQuery("[data-category=" + collection + "]").show();
    
    
    jQuery('.custom-small-gallery [data-category]')
    .hide()
    .removeClass("js-masonry-item");
    
    jQuery('.custom-small-gallery [data-category=' + collection + ']')
    .show()
    .addClass("js-masonry-item");

    setTimeout(function(){
        rebuildMasonry();
        rebuildLargeGallery()
        
      }, 500);


    $(".gallery-sec").addClass("filter-active");
    jQuery.fancybox.destroy();
    jQuery().fancybox({
      selector:
        ".custom-large-gallery .masonry-gallery-box .item-box-wrap:visible a, .custom-small-gallery .masonry__item:visible a",
      caption: function (instance, item) {
        return jQuery(this).find(".caption").html();
      },
    });

  }
});
jQuery(window).on("load scroll", function () {
  var siteHeaderHeight = jQuery(".site-header").height();
  var scroll = jQuery(window).scrollTop();
  if (scroll >= 200) {
    jQuery(".header-light-container .site-header").removeClass("header-light");
  } else {
    jQuery(".header-light-container .site-header").addClass("header-light");
  }
  if (jQuery(".single-product-nav").length > 0) {
    var navOffTop =
      jQuery(".single-product-details .single-product-nav").offset().top -
      siteHeaderHeight;
    if (scroll >= navOffTop) {
      jQuery(".single-product-details .single-product-nav").addClass(
        "higher-index"
      );
      jQuery("header.site-header").css("visibility", "hidden");
      jQuery("header.site-header .site-nav-wrap").removeClass("menu-active");
      jQuery(".site-header__icons .site-nav-toggle-btn").removeClass(
        "menu-close"
      );
      jQuery("header.site-header .mega-menu-box").removeClass(
        "mega-menu-active"
      );
      jQuery(".site-header").removeClass("header-light-inner");
    } else {
      jQuery(".single-product-details .single-product-nav").removeClass(
        "higher-index"
      );
      jQuery("header.site-header").css("visibility", "visible");
    }
  }
});
jQuery(window).bind("load", function () {
  setTimeout(function () {
    AOS.init({ duration: 1000, offset: 110, once: !1 });
  }, 400);
});
jQuery(window).on("load resize", function () {
  if (jQuery(window).width() < 992) {
    jQuery(
      ".custom-projects-list .list-table-box table tr td:not(:last-of-type)"
    ).click(function () {
      jQuery(".custom-projects-list .list-table-box table tr").removeClass(
        "active"
      );
      jQuery(this).parents("tr").addClass("active");
    });
    jQuery(document).on("click", function (event) {
      if (
        !jQuery(event.target).closest(
          ".custom-projects-list .list-table-box table tr td"
        ).length
      ) {
        jQuery(".custom-projects-list .list-table-box table tr").removeClass(
          "active"
        );
      }
    });
  }
  $(".product-customization-sec .content-row").slick("refresh");
});
jQuery(window).bind("load", function () {
  if (document.readyState === "complete") {
    setTimeout(function () {
      jQuery(".loader").fadeOut(500);
      AOS.init({ once: !0, duration: 1000 });
    }, 500);
  }
});




$(document).ready(function(){

const targets = document.querySelectorAll('[data-in-view="once"]');

const ioInView = (target)=>{
  const io = new IntersectionObserver((entries,observer)=>{
      entries.forEach(entry=>{
          if(entry.isIntersecting){
              //console.log(entry.target)
              entry.target.classList.add('is-in-view')
          }
      })
  });

  io.observe(target);
}
targets.forEach(ioInView);

});





function videoAutoPlay() {
    setTimeout(function () {
        var videoSource = $('.is-selected').find('.fancybox__iframe').attr('src');
        $('.is-selected').find('.fancybox__iframe').attr('src', videoSource + '&autoplay=1');
    }, 2000);
}




$(document).ready(function(){

  const rightWidth = $('.grid__item--product-content').outerWidth();
  console.log(rightWidth);

  $( ".template-product.new .product-form__controls-group--submit" ).css('width', rightWidth);

  
//$( ".template-product.new .grid__item--product-content" ).append( $( ".template-product.new .product-form__controls-group--submit" ) );

});

